import styled from "styled-components";

export const HeaderStyles = styled.div`

ul {
    margin: 0;
}

li {
    margin: 0 0.5rem ;
    list-style-type: none;
}

svg.clock{
    font-size:1.1rem;
    margin: 0 0.5rem ;
    margin-top:0.16rem;
    color: var(--yellow);
} 

.horario {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
}

img {
    margin: 0 0 0 3.5rem;
}
`
